import React from 'react';
import './MultiTable.scss';
import {formatToPersianAddComma} from "../../../../../utils/CommaSeparator";
import numericFunction from "../../../../../utils/NumericFunction";

const MultiTable = ({setSendData, sendData}) => {

    function deleteServiceHandler(id) {
        let tempArray = sendData.services;
        tempArray = tempArray.filter(v => v.id !== id)

        setSendData({...sendData, services: tempArray})
    }

    function deleteProductHandler(id) {
        let tempArray = sendData.products;
        tempArray = tempArray.filter(v => v.id !== id)
        setSendData({...sendData, products: tempArray})
    }

    const changeProductHandler = (e, id) => {

        let tempArray = [...sendData.products];
        for (let i = 0; i < tempArray.length; i++) {
            if (tempArray[i].id === id) {
                tempArray[i].number = numericFunction.p2e(e.target.value)
                break;
            }
        }

        setSendData({...sendData, products: tempArray})
    }

    // const changeServiceHandler = (e, id) => {
    //
    //     let tempArray = [...sendData.services];
    //     for (let i = 0; i < tempArray.length; i++) {
    //         if (tempArray[i].id === id) {
    //             tempArray[i].number = "1"
    //             break;
    //         }
    //     }
    //
    //     setSendData({...sendData, services: tempArray})
    // }

    const totalPriceHandler = (a, b, c) => {
        return ((b - c) * a)
    }

    return (

        <div className="main-table-factor">

            {(sendData?.products.length > 0 || sendData?.services.length > 0) &&

                <>
                    <ul className="header-side-f">
                        <li style={{width: "3%"}}></li>
                        <li style={{width: "27%"}}>عنوان</li>
                        <li style={{width: "15%"}}>تعداد</li>
                        <li style={{width: "15%"}}>قیمت</li>
                        <li style={{width: "15%"}}>تخفیف</li>
                        <li style={{width: "15%"}}>قیمت کل</li>
                        <li style={{width: "10%"}}>عملیات</li>
                    </ul>

                    {sendData.products?.map((v, index) =>

                        <ul className="row-side-f" key={"p" + index}>
                            <li style={{width: "3%", paddingRight: "15px"}}>
                                <svg width="18" height="18" viewBox="0 0 18 18" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M9.00068 9.97508C9.09818 9.97508 9.19568 9.95258 9.28568 9.90008L15.9082 6.06758C16.1707 5.91008 16.2682 5.56508 16.1107 5.29508C15.9532 5.02508 15.6082 4.93508 15.3382 5.09258L9.00068 8.76008L2.70068 5.11508C2.43068 4.95758 2.08568 5.05508 1.92818 5.31758C1.77068 5.58758 1.86818 5.93258 2.13068 6.09008L8.70818 9.90008C8.80568 9.94508 8.90318 9.97508 9.00068 9.97508Z"
                                        fill="#FF8938"/>
                                    <path
                                        d="M9 16.77C9.3075 16.77 9.5625 16.515 9.5625 16.2075V9.405C9.5625 9.0975 9.3075 8.8425 9 8.8425C8.6925 8.8425 8.4375 9.0975 8.4375 9.405V16.2075C8.4375 16.515 8.6925 16.77 9 16.77Z"
                                        fill="#FF8938"/>
                                    <path
                                        d="M8.99955 17.0625C9.65955 17.0625 10.312 16.92 10.8295 16.635L14.8345 14.4075C15.922 13.8075 16.7695 12.36 16.7695 11.115V6.8775C16.7695 5.6325 15.922 4.1925 14.8345 3.585L10.8295 1.365C9.80205 0.795 8.19705 0.795 7.16955 1.365L3.16455 3.5925C2.07705 4.1925 1.22955 5.64 1.22955 6.885V11.1225C1.22955 12.3675 2.07705 13.8075 3.16455 14.415L7.16955 16.635C7.68705 16.92 8.33955 17.0625 8.99955 17.0625ZM8.99955 2.0625C9.47205 2.0625 9.93705 2.16 10.282 2.3475L14.287 4.575C15.007 4.9725 15.6445 6.0525 15.6445 6.8775V11.115C15.6445 11.94 15.007 13.02 14.287 13.425L10.282 15.6525C9.59955 16.035 8.39955 16.035 7.71705 15.6525L3.71205 13.425C2.99205 13.02 2.35455 11.9475 2.35455 11.115V6.8775C2.35455 6.0525 2.99205 4.9725 3.71205 4.5675L7.71705 2.34C8.06205 2.16 8.52705 2.0625 8.99955 2.0625Z"
                                        fill="#FF8938"/>
                                </svg>
                            </li>
                            <li style={{width: "27%"}}>{v?.title}</li>
                            <li style={{width: "15%"}}>
                                <input id={"id" + index} type="text" value={numericFunction.e2p(v?.number)} onChange={e => changeProductHandler(e, v.id)}/>
                            </li>
                            <li style={{width: "15%"}}>{formatToPersianAddComma(v?.price)}</li>
                            <li style={{width: "15%"}}>{formatToPersianAddComma(v?.discount)}</li>
                            <li style={{width: "15%"}}>
                                {formatToPersianAddComma(totalPriceHandler(v?.number, v?.price, v?.discount))}
                            </li>
                            <li style={{width: "10%"}}>
                                <div className={"delete-side"} onClick={() => deleteProductHandler(v.id)}>
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                         xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M9.16936 15.5801C8.97936 15.5801 8.78938 15.5101 8.63938 15.3601C8.34938 15.0701 8.34938 14.5901 8.63938 14.3001L14.2994 8.64011C14.5894 8.35011 15.0694 8.35011 15.3594 8.64011C15.6494 8.93011 15.6494 9.41011 15.3594 9.70011L9.69936 15.3601C9.55936 15.5101 9.35936 15.5801 9.16936 15.5801Z"
                                            fill="#FB6B7A"/>
                                        <path
                                            d="M14.8294 15.5801C14.6394 15.5801 14.4494 15.5101 14.2994 15.3601L8.63938 9.70011C8.34938 9.41011 8.34938 8.93011 8.63938 8.64011C8.92937 8.35011 9.40936 8.35011 9.69936 8.64011L15.3594 14.3001C15.6494 14.5901 15.6494 15.0701 15.3594 15.3601C15.2094 15.5101 15.0194 15.5801 14.8294 15.5801Z"
                                            fill="#FB6B7A"/>
                                        <path
                                            d="M15 22.75H9C3.57 22.75 1.25 20.43 1.25 15V9C1.25 3.57 3.57 1.25 9 1.25H15C20.43 1.25 22.75 3.57 22.75 9V15C22.75 20.43 20.43 22.75 15 22.75ZM9 2.75C4.39 2.75 2.75 4.39 2.75 9V15C2.75 19.61 4.39 21.25 9 21.25H15C19.61 21.25 21.25 19.61 21.25 15V9C21.25 4.39 19.61 2.75 15 2.75H9Z"
                                            fill="#FB6B7A"/>
                                    </svg>
                                </div>
                            </li>
                        </ul>
                    )}

                    {sendData.services?.map((v, index) =>

                        <ul className="row-side-f" key={"s" + index}>
                            <li style={{width: "3%", paddingRight: "15px"}}>
                                <svg width="18" height="18" viewBox="0 0 18 18" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M11.6932 9.7575C9.26317 9.7575 7.2832 7.7775 7.2832 5.3475C7.2832 2.9175 9.26317 0.9375 11.6932 0.9375C14.1232 0.9375 16.1032 2.9175 16.1032 5.3475C16.1032 7.7775 14.1232 9.7575 11.6932 9.7575ZM11.6932 2.0625C9.88567 2.0625 8.40817 3.5325 8.40817 5.3475C8.40817 7.1625 9.87817 8.6325 11.6932 8.6325C13.5082 8.6325 14.9782 7.1625 14.9782 5.3475C14.9782 3.5325 13.5007 2.0625 11.6932 2.0625Z"
                                        fill="#33B0B1"/>
                                    <path
                                        d="M4.77093 15.1425C3.18843 15.1425 1.89844 13.8525 1.89844 12.27C1.89844 10.6875 3.18843 9.39751 4.77093 9.39751C6.35343 9.39751 7.64348 10.6875 7.64348 12.27C7.64348 13.8525 6.35343 15.1425 4.77093 15.1425ZM4.77093 10.5225C3.81093 10.5225 3.02344 11.3025 3.02344 12.27C3.02344 13.23 3.80343 14.0175 4.77093 14.0175C5.73093 14.0175 6.51844 13.2375 6.51844 12.27C6.51844 11.31 5.73093 10.5225 4.77093 10.5225Z"
                                        fill="#33B0B1"/>
                                    <path
                                        d="M12.4653 17.0624C11.0928 17.0624 9.98285 15.9449 9.98285 14.5799C9.98285 13.2074 11.1003 12.0974 12.4653 12.0974C13.8303 12.0974 14.9478 13.2149 14.9478 14.5799C14.9478 15.9449 13.8303 17.0624 12.4653 17.0624ZM12.4653 13.2149C11.7153 13.2149 11.1078 13.8224 11.1078 14.5724C11.1078 15.3224 11.7153 15.9299 12.4653 15.9299C13.2153 15.9299 13.8228 15.3224 13.8228 14.5724C13.8228 13.8299 13.2153 13.2149 12.4653 13.2149Z"
                                        fill="#33B0B1"/>
                                </svg>
                            </li>
                            <li style={{width: "27%"}}>{v?.title}</li>
                            <li style={{width: "15%"}}>
                                <p>{formatToPersianAddComma(v?.number)}</p>
                            </li>
                            <li style={{width: "15%"}}>{formatToPersianAddComma(v?.price)}</li>
                            <li style={{width: "15%"}}>{formatToPersianAddComma(v?.discount)}</li>
                            <li style={{width: "15%"}}>
                                {formatToPersianAddComma(totalPriceHandler(v?.number, v?.price, v?.discount))}
                            </li>
                            <li style={{width: "10%"}}>
                                <div className={"delete-side"} onClick={() => deleteServiceHandler(v.id)}>
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                         xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M9.16936 15.5801C8.97936 15.5801 8.78938 15.5101 8.63938 15.3601C8.34938 15.0701 8.34938 14.5901 8.63938 14.3001L14.2994 8.64011C14.5894 8.35011 15.0694 8.35011 15.3594 8.64011C15.6494 8.93011 15.6494 9.41011 15.3594 9.70011L9.69936 15.3601C9.55936 15.5101 9.35936 15.5801 9.16936 15.5801Z"
                                            fill="#FB6B7A"/>
                                        <path
                                            d="M14.8294 15.5801C14.6394 15.5801 14.4494 15.5101 14.2994 15.3601L8.63938 9.70011C8.34938 9.41011 8.34938 8.93011 8.63938 8.64011C8.92937 8.35011 9.40936 8.35011 9.69936 8.64011L15.3594 14.3001C15.6494 14.5901 15.6494 15.0701 15.3594 15.3601C15.2094 15.5101 15.0194 15.5801 14.8294 15.5801Z"
                                            fill="#FB6B7A"/>
                                        <path
                                            d="M15 22.75H9C3.57 22.75 1.25 20.43 1.25 15V9C1.25 3.57 3.57 1.25 9 1.25H15C20.43 1.25 22.75 3.57 22.75 9V15C22.75 20.43 20.43 22.75 15 22.75ZM9 2.75C4.39 2.75 2.75 4.39 2.75 9V15C2.75 19.61 4.39 21.25 9 21.25H15C19.61 21.25 21.25 19.61 21.25 15V9C21.25 4.39 19.61 2.75 15 2.75H9Z"
                                            fill="#FB6B7A"/>
                                    </svg>
                                </div>
                            </li>
                        </ul>
                    )}
                </>
            }
        </div>
    );
};
export default MultiTable;